
import { validationMixin } from 'vuelidate'
import { email, required, minLength, sameAs, helpers } from 'vuelidate/lib/validators'

import breadcrumbsMixin from '~/mixins/breadcrumbs/breadcrumbsMixin'
import registerMixin from '~/mixins/auth/registerMixin'

const pwdValidator = helpers.regex('pwdValidator', /((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).{8,}$/)

export default {
  mixins: [
    breadcrumbsMixin,
    validationMixin,
    registerMixin
  ],

  validations: {
    form: {
      name: { required, minLength: minLength(3) },
      email: { required, email },
      password: { required, pwdValidator },
      password2: { required, sameAs: sameAs('password') }
    }
  },

  layout: 'empty',

  asyncData ({ $config, i18n, localePath }) {
    let breaditems = [
      {
        text: i18n.t('signup_freelancer.title'),
        disabled: true,
        href: $config.baseUrl + localePath({ name: 'signup-freelancer' })
      }
    ]
    breaditems = breadcrumbsMixin.methods.breadcrumbsItems(breaditems, localePath)

    const breadldjson = breadcrumbsMixin.methods.breadcrumbsLdJson(breaditems)

    return {
      breaditems,
      breadldjson
    }
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password2: ''
      },
      loading: false
    }
  },

  head () {
    return {
      title: this.$t('signup_freelancer.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('signup_freelancer.desc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.$t('signup_freelancer.desc')
        },
        { hid: 'og:title', name: 'og:title', content: this.$t('signup_freelancer.title') },
        { hid: 'og:url', name: 'og:url', content: this.$config.baseUrl + this.localePath({ name: 'signup-freelancer' }) }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.breadldjson
        }
      ]
    }
  },

  computed: {
    formInvalid () {
      return this.$v.$invalid
    }
  },

  created () {
    if (!!this.$auth.loggedIn) {
      this.$router.replace(this.localePath({ name: 'dashboard' }))
    }
  },

  async mounted () {
    if (!!this.$recaptcha) {
      await this.$recaptcha.init()
    }
    if (!!window) {
      window.addEventListener('beforeunload', this.unloadListener)
    }
  },

  methods: {
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },

    async unloadListener () {
      if (!!this.$recaptcha) {
        await this.$recaptcha.destroy()
      }
      window.removeEventListener('beforeunload', this.unloadListener)
    },

    async onSubmit (e) {
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!this.loading) {
        return
      }
      e.preventDefault()
      this.loading = true

      let token = false
      try {
        token = await this.$recaptcha.execute('register')
      } catch (e) {
        console.log('reCaptcha Error:', e)
      }

      if (token) {
        try {
          let res = false

          const fields = Object.assign({}, this.form)
          fields.rct = token
          res = await this.apiRegistrationRegisterEmail(fields)
          if (!res?.success) {
            this.$bvToast.toast(res.details ? res.details : (!!res.message ? res.message : res.exception), {
              title: this.$t('toast.header.error'),
              variant: 'danger',
              solid: true
            })
          } else {
            if (!!this.$gtag) {
              this.$gtag('event', 'signup', { type: 'freelacer' })
            }

            this.$bvToast.toast(this.$t('toast.message.success'), {
              title: this.$t('toast.header.success'),
              variant: 'success',
              solid: true
            })

            this.$refs.form.reset()
            this.$v.form.$reset()

            setTimeout(() => {
              this.unloadListener()
              this.$router.push(this.localePath({ name: 'login' }))
            }, 5000)
          }
        } catch (e) {
          this.$bvToast.toast(e.message, {
            title: this.$t('toast.header.error'),
            variant: 'danger',
            solid: true
          })
        }
      }

      this.loading = false
    }
  }
}
